import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { purchases } from '../data/purchases';
import { BRAND } from '../data/site';
export function PurchasePopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Mostrar el primer popup después de 5 segundos
    const initialDelay = setTimeout(() => {
      setIsVisible(true);

      // Ocultar después de 5 segundos
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 5000);

    // Luego, repetir cada 15 segundos
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setIsVisible(true);

      // Ocultar después de 5 segundos
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  const purchase = purchases[currentIndex];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 flex justify-center sm:bottom-6 sm:left-6 sm:right-auto sm:justify-start" data-id="element-180" data-mp="163mqde9wib1d">
      <AnimatePresence data-id="element-181" data-mp="1fuhaabzocyjn">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-4 rounded-2xl border border-gold-200/60 bg-cream p-4 shadow-[0_20px_40px_-15px_rgba(56,52,44,0.3)]" data-id="element-182" data-mp="1awpirj2xzefz">
            <div className="relative flex-none" data-id="element-183" data-mp="s5evrd0c7ltd">
              <img src={BRAND.ebookMockup} alt="Deco Flores" className="h-14 w-12 object-cover drop-shadow-md" data-id="element-184" data-mp="28kg4elsq7lv6" />
              <div className="absolute -bottom-1 -right-1 rounded-full bg-cream p-0.5" data-id="element-185" data-mp="23l3ettah00ow">
                <CheckCircle2Icon className="h-4 w-4 text-sage-600" data-id="element-186" data-mp="2ao1qz900i9v1" />
              </div>
            </div>
            <div className="flex-1" data-id="element-187" data-mp="2fltgjwd6pjw2">
              <p className="text-[13px] leading-snug text-ink-soft" data-id="element-188" data-mp="2kn0njt7i6f1o">
                <strong className="font-semibold text-sage-800" data-id="element-189" data-mp="2kko4tdtx80nk">{purchase.name}</strong> de{' '}
                <strong className="font-semibold text-sage-800" data-id="element-190" data-mp="2pjrcl61ackz8">{purchase.location}</strong>
              </p>
              <p className="mt-0.5 text-[12px] text-ink-light" data-id="element-191" data-mp="1rw8sx0635ygg">
                Adquirió la guía Deco Flores
              </p>
              <p className="mt-1 text-[10.5px] font-medium uppercase tracking-wider text-terracotta-500" data-id="element-192" data-mp="21vpylhlc8ccf">
                {purchase.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}